import React from "react";

export function Disclaimer() {
  return (
    <div className="border-b border-white/5 bg-[#0A0A0A]">
      <p
        data-testid="customer-disclaimer"
        className="max-w-screen-2xl mx-auto px-5 sm:px-8 py-1.5 text-left text-[11px] leading-snug text-white/40"
      >
        The stock mentioned can vary with the actual quantity available, please call or WhatsApp
        8010307363 / 7020006164 for more information.
      </p>
    </div>
  );
}
